import React from "react";

import { formatDateString, phoneNumberFormat } from "../../utils/format";
import { renderArchived, renderBusinessName } from "../../utils/actions";

import { ClientsPage } from "./ClientsPage";

export class YourClients extends React.Component {
  render() {
    var search = this.props.location.query
      ? this.props.location.query.search
      : "";
    const columnsSet = [
      {
        data: "id",
        visible: false,
        searchable: false,
        targets: [0],
      },
      {
        data: "archived",
        title: "Archive",
        width: "50px",
        autowidth: false,
        targets: [1],
        orderable: false,
        render: renderArchived,
      },
      {
        data: "businessName",
        width: "auto",
        autowidth: true,
        title: "Client",
        targets: [2],
        defaultContent: "",
        className: "",
        render: renderBusinessName,
      },
      {
        data: "clientId",
        title: "Client ID",
        width: "70px",
        autowidth: false,
        targets: [3],
        className: "col-fw-70px",
      },
      {
        data: "primaryContactPhone",
        title: "Phone",
        width: "100px",
        autowidth: false,
        targets: [4],
        render: phoneNumberFormat,
        className: "col-fw-100px",
      },
      {
        data: "producerId",
        title: "Producer ID",
        visible: false,
        searchable: false,
        targets: [5],
      },
      {
        data: "producer",
        title: "Agency User",
        width: "170px",
        autowidth: false,
        targets: [6],
        className: "col-fw-170px o-vis",
      },
      {
        data: "status",
        title: "Status",
        autowidth: false,
        targets: [7],
      },
      {
        data: "submittedDate",
        title: "Submit Date",
        width: "110px",
        autowidth: false,
        targets: [8],
        render: formatDateString,
        defaultContent: "",
        className: "col-fw-110px",
      },
      {
        data: "actions",
        title: "",
        targets: [9],
        orderable: false,
        className: "btn-column w-100",
      },
    ];

    return (
      <div>
        <ClientsPage
          search={search}
          columns={columnsSet}
          order={[[2, "asc"]]}
          settings={{ allowProducerDropDown: true }}
          pageHeader="Clients"
          clientTypes={[
            { name: "All Clients", value: "AllClients" },
            { name: "In-Force", value: "InForce" },
            { name: "Expired Policies", value: "ExpiredPolicies" },
            { name: "Future Policies", value: "FuturePolicies" },
            { name: "New Business YTD", value: "NewBusiness" },
            { name: "Renewed YTD", value: "Renewed" },
          ]}
          clientType="AllClients"
          unsubmittedClients={false}
          statisticItems={[
            { name: "Clients", value: 0, icon: "client-counter.svg" },
            { name: "Policies", value: 0, icon: "policies.svg" },
            { name: "Premiums", value: 0, icon: "premiums.svg" },
          ]}
          getUpdatedStatisticsCallback={(data) => {
            var extraData = data.extraData;
            var statiscticsItems = [];

            statiscticsItems.push({
              name: "Clients",
              value: data.recordsTotal,
              icon: "client-counter.svg",
            });
            statiscticsItems.push({
              name: "Policies",
              value: extraData.PoliciesCount,
              icon: "policies.svg",
            });
            statiscticsItems.push({
              name: "Premiums",
              value: extraData.TotalPremium,
              icon: "premiums.svg",
            });
            return statiscticsItems;
          }}
        />
      </div>
    );
  }
}
